import { render, staticRenderFns } from "./LinkFieldMultiple.vue?vue&type=template&id=1a56f1f9"
import script from "./LinkFieldMultiple.vue?vue&type=script&lang=js"
export * from "./LinkFieldMultiple.vue?vue&type=script&lang=js"
import style0 from "./LinkFieldMultiple.vue?vue&type=style&index=0&id=1a56f1f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports